module.exports = __webpack_public_path__ + "static/OneDotCd-BoldItalic.053e2a25.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotCd-BoldItalic.woff
// module id = 742
// module chunks = 114276838955818